// extracted by mini-css-extract-plugin
export default {"tooltipTitle":"AdjustedAmountTooltip_tooltipTitle__4c-Z3","tooltipText":"AdjustedAmountTooltip_tooltipText__QI2eO","tooltipDivider":"AdjustedAmountTooltip_tooltipDivider__-3pHW"};